export default "__VITE_ASSET__Cx6RzE7r__"